import * as performanceTiming from './helpers/performanceTiming';

export { addE2ETimeToDiagnosticsStore } from './actions/addE2ETimeToDiagnosticsStore';

export { getSearchRequestInstrumentation } from './helpers/getSearchRequestInstrumentation';

export { performanceTiming };

export { lazyAddSearchRequestInstrumentation, lazyAddResourceTimingEntry } from './lazyModule';
export { PerformanceDatapoint } from 'owa-analytics';
